import { Klass, u_ } from "@pressmedia/webappbase";

Object.assign(Klass("VuwFileset").prototype, {
	getFileUrl(ext) {
		if( !ext || !u_.isString(ext) ) {
			return false;
		}
		
		const vuwForm = this.getForm();
		if( !( vuwForm instanceof Klass("VuwJbForm") ) ) {
			return false;
		}
		
		return [
			vuwForm.config.fileDir || "",
			this.dataType,
			this.paramKey.split("_").map((v, i) => {
				if(i) {
					return `${v.replace(/^0/, "")}.${ext}`;
				} else {
					return v + vuwForm.getDataId();
				}
			}).join("_")
		].join("/");
	}
});
